module.exports = __webpack_public_path__ + "static/hub-orange-9e1e8ca6bd4d7b6b4bd3ef32a5041964.png";